import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Link } from 'react-router-dom'

// Components
import PriceCard from './PriceCard.js'
import FAQ from './FAQ.js'
import Demo from '../demo/Demo.js'

// MUI
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

// Helpers
import { standardButton, socialMediaButtons } from '../../helpers/buttons.js'
import { positionChangeWidthSm, positionChangeWidthMd, navbarHeight, iconImageDimension, swipelyticsTurquoise } from '../../helpers/variableDefaults.js'
import useWindowDimensions from '../../helpers/windowDimensions.js'
import { videoInsert } from '../../helpers/videos.js'
import { shuffleArray, isInstagramOrFacebook, handleOpenInBrowser } from '../../helpers/globalHelpers.js'

import { seoPageTags, customAnalyticsEvent, registerPageViewsInsideMetaBrowser, runGTAGScript, customGTAGHead } from '../../helpers/analytics.js'

// Assets
import betterMatchesIcon from '../../assets/icon-better-matches.png'
import optimizedProfilesIcon from '../../assets/icon-optimized-profiles.png'
import detailedFeedbackIcon from '../../assets/icon-detailed-feedback.png'
import aiReviewIconBlue from '../../assets/ai-icon-blue-eyes.png'
import friendReviewIconBlue from '../../assets/friend-icon-blue-head.png'
import expertReviewIconBlue from '../../assets/expert-icon-blue-gavel.png'

import hingeLogoWhite from '../../assets/hinge-white-400x100.png'
import bumbleLogoWhite from '../../assets/bumble-white-400x100.png'
import tinderLogoWhite from '../../assets/tinder-white-400x100.png'

const datingAppLogosArray = [hingeLogoWhite, tinderLogoWhite, bumbleLogoWhite]

import heroImage1 from '../../assets/hero-flowers-on-bed-1-sat-minus-45.png'
import heroImage2 from '../../assets/hero-girl-on-phone-2-sat-minus-60.png'
import heroImage3 from '../../assets/hero-girl-in-field-3-sat-minus-70.png'
import heroImage4 from '../../assets/hero-girl-in-hat-bw-lightness-75.png'
import heroImage5 from '../../assets/hero-roses-1-sat-minus-60.png'

const heroImage = shuffleArray([heroImage1, heroImage2, heroImage3, heroImage4, heroImage5])[0]
// const heroImage = heroImage2

// Home Page
const Home = () => {

  // use Naviage
  const navigate = useNavigate()

  // Window Dimensions
  const { height, width } = useWindowDimensions()

  useEffect(() => {
    const checkForMetaBrowser = () => {
      if (isInstagramOrFacebook()) {
        const timeout = setTimeout(() => {
          // console.log('⏱️ Delayed effect: 250ms later');
          // Put your delayed logic here
          registerPageViewsInsideMetaBrowser('Home')
        }, 250) // delay in milliseconds

        return () => clearTimeout(timeout)
      }
    }
    
    checkForMetaBrowser()

  }, [])

  // Navigate to /create-account when Create Account button Clicked
  const handleCreateAccountPressed = async (e) => {
    e.preventDefault()
    // console.log('handleCreateAccountPressed')

    // console.log('!isInstagramOrFacebook() ->', !isInstagramOrFacebook())

    if (
      !isInstagramOrFacebook()
      // || isInstagramOrFacebook()
    ) {
      // console.log('not ig or fb browser')
      navigate('/create-account')
    } else {
      // console.log('yes ig or fb browser')
      navigate('/create-account')
      // handleOpenInBrowser('create-account')
    }
    
  }

  // Navigate to /demo when Demo button Clicked
  const handleDemo = async (e) => {
    e.preventDefault()
    console.log('handleDemo runs')
    // navigate(`/demo/carrie/hinge/mrbig/view-feedback?homepage`, { state: { previousLocationPathname: `${window.location.pathname}?homepage` } })
    navigate(`/demo/ted/hinge/robin/view-feedback?homepage`, { state: { previousLocationPathname: `${window.location.pathname}?homepage` } })

  }

  // Graphics Plus Text for 'Detailed Feedback; Optimized Profiles; Better Matches'
  const iconImagePlusText = (image, text, subText = '') => {
    return (
      <>
        <Box
          sx={{
            // backgroundColor: 'whitesmoke',
            // boxShadow: 3,
            height: '100%',
            width: width > positionChangeWidthSm ? '25%' : '80%',
            display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
          }}
        >
          {/* Image */}
          <Box
            sx={{
              height: iconImageDimension,
              width: iconImageDimension,
              backgroundImage: `url(${image})`,
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              display: 'inline-block',
            }}
          />

          {/* Text */}
          <Typography
            sx={{
              mt: -1,
              height: '20%',
              fontWeight: 'bold',
              fontSize: '18px',
              // color: 'white',
            }}
          >
            {text}
          </Typography>

          {/* Sub-Text */}
          {subText.length > 0 &&
            <Typography
              sx={{
                mt: 
                  (width >= positionChangeWidthSm && (text === 'Detailed Feedback' || text === 'Optimized Profiles' || text === 'Better Matches')) 
                    ? 
                    0 
                    :
                    (width >= positionChangeWidthSm && (text !== 'Detailed Feedback' || text !== 'Optimized Profiles' || text !== 'Better Matches'))
                      ?
                      -2
                      : 
                      -1,
                height: '20%',
                fontWeight: 'bold',
                fontSize: '14px',
                // color: 'white',
              }}
            >
              {`${subText}`}
            </Typography>
          }
        
        </Box>
      </>
    )
  }

  const singleTestimonialJSX = (testimonialText) => {
    return (
      <Box
        sx={{
          py: 6, px: 2,
          backgroundColor: 'mistyrose',
          // backgroundColor: 'lightyellow',
          // backgroundColor: 'lightblue',
          boxShadow: 3,
          width: '100%',
          display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
        }}
      >
        <Typography
          textAlign={'center'}
          sx={{
            my: 2,
            width: '100%',
            maxWidth: '600px',
            fontStyle: 'italic',
            fontWeight: 'bold',
            // fontFamily: 'Satisfy',
            fontSize: '24px',
            // color: '#404040',
            color: 'dimgray',
            // color: 'black',
            display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'flex-start',
          }}
        >
          {testimonialText}
        </Typography>
      </Box>
    )
  }

  return (
    <>
      {/* Helmet — for analytics, seo, and page title changing */}
      {
        // !isInstagramOrFacebook() &&
        // || isInstagramOrFacebook()
        seoPageTags(
          'Home'
        )
      }

      {/* Body */}
      <Box 
        sx={{ 
          height: `calc(100% - ${navbarHeight})`, width: '100vw', 
          display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', 
        }}
      >
        
        {/* Hero */}
        <Box 
          sx={{
            width: '100%', height: width > positionChangeWidthSm ? '60vh' : '70vh',
            backgroundImage: `url(${heroImage})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            overflow: 'hidden',
            display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
          }}
        >
          {/* Header */}
          <Typography 
            variant="h1"
            textAlign={'center'}
            sx={{  
              // backgroundColor: 'yellow',
              width: '90%',
              fontFamily: 'Raleway',
              fontSize: '40px',
              lineHeight: '40px',
              fontWeight: 'bold',
            }}
          >
            Optimize Your Dating Profile
          </Typography>

          {/* Subheader */}
          <Typography 
            variant="h2"
            textAlign={'center'}
            sx={{  
              mt: 2,
              width: '90%',
              fontFamily: 'Raleway',
              fontSize: '25px',
              lineHeight: '35px',

              fontWeight: 'bold',
            }}
          >
            Display Your Most Attractive Self With Expert Feedback
          </Typography>

          {/* Create Account Button */}
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            {standardButton(
              'Sign Up Free', 
              'button',
              'contained',
              false,
              'primary', 
              4,
              0,
              0,
              '180px', 
              '45px', 
              handleCreateAccountPressed
            )}
          </Box>

          {/* Demo Button */}
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            {standardButton(
              'See Example', 
              'button',
              'contained',
              false,
              'secondary', 
              2,
              0,
              0,
              '180px', 
              '45px', 
              handleDemo
            )}
          </Box>
        </Box>


        {/* Dating App Interfaces */}
        <Box 
          sx={{
            // mt: 2, mb: 2,
            backgroundColor: '#616161',
            py: width > positionChangeWidthSm ? 6 : 5,
            width: '100%', 
            // height: width > positionChangeWidthSm ? '225px' : '600px',
            // backgroundColor: 'yellow',
            display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
          }}
        >
          {(
            width > positionChangeWidthSm 
            || width <= positionChangeWidthSm
          )
          &&
            <Typography
              textAlign={'center'}
              sx={{
                // my: 1,
                mb: width <= positionChangeWidthSm ? 1.5 : 1,
                width: '90%',
                // maxWidth: '600px',
                // fontStyle: 'italic',
                fontWeight: 'bold',
                fontSize: width <= positionChangeWidthSm ? '18px' : '20px',
                color: 'white',
                display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
              }}
            >
              {`Dating App Interfaces`}
            </Typography>
          }

          {/* Logos */}
          <Box
            sx={{
              // py: 3,
              mt: width > positionChangeWidthSm ? 0 : 0,
              width: '90%',
              // maxWidth: '900px',
              display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
              flexWrap: 'wrap',
            }}
          >
            {datingAppLogosArray.map((datingAppLogo, datingAppLogoIndex) => (
              <Box
                key={datingAppLogoIndex}
                sx={{
                  mt: width > positionChangeWidthSm ? 0 : 0, mx: 2,
                  width: width < 450 ? '100%' : '25%',
                  display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: (width < positionChangeWidthSm || datingAppLogoIndex % 3 === 1) ? 'center' : datingAppLogoIndex % 3 === 0 ? 'flex-end' : 'flex-start',
                  // flexWrap: 'wrap',
                }}
              >
                <Box 
                  sx={{ 
                    // mt: width > positionChangeWidthSm ? 1 : 0,
                    mt: width <= positionChangeWidthSm && datingAppLogoIndex === 0 ? 0 : 1,
                    // backgroundColor: 'gray',
                    backgroundImage: `url(${datingAppLogo})`,
                    width: width < 350 ? '140px' : width < 450 ? '140px' : width < 515 ? '140px' : width < 560 ? '140px' : width < 595 ? '140px' : width < 650 ? '140px' : width < 800 ? '140px' : width < 1030 ? '140px' : width < 1200 ? '140px' : '140px',
                    height: width < 350 ? '35px' : width < 450 ? '35px' : width < 515 ? '35px' : width < 560 ? '35px' : width < 595 ? '35px' : width < 650 ? '35px' : width < 800 ? '35px' : width < 1030 ? '35px' : width < 1200 ? '35px' : '35px',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    // boxShadow: 3, 
                    // borderRadius: '5px', 
                    // cursor: tapDisabled() ? '' : 'pointer',
                    display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', 
                  }}
                />
              </Box>
            ))}
          </Box>

        </Box>

        {/* Graphics with Text Underneath */}
        <Box 
          sx={{
            // mt: 2, mb: 2,
            pt: 5, pb: 5,
            width: '100%', height: width > positionChangeWidthSm ? '225px' : '600px',
            // backgroundColor: 'darkgray',
            display: 'flex', flexDirection: width > positionChangeWidthSm ? 'row' : 'column', justifyContent: 'space-around', alignItems: 'center',
          }}
        >

          {/* Detailed Feedback Image + Text */}
          {iconImagePlusText(detailedFeedbackIcon, 'Detailed Feedback', 'Analysis + Verdict')}

          {/* Optimized Profiles Image + Text */}
          {iconImagePlusText(optimizedProfilesIcon, 'Optimized Profiles', 'Dealbreakers Eliminated')}

          {/* Better Matches Image + Text */}
          {iconImagePlusText(betterMatchesIcon, 'Better Matches', 'Better Dates. Better Love.')}
        </Box>



        {/* Testimonial 1 */}
        {/* {singleTestimonialJSX(
          `"Pinpointing and eliminating dealbreaker images helped me meet my husband" — Maria, 34, San Francisco`
        )} */}



        {/* Introduction Video */}
        <Box
          sx={{
            mt: 0, 
            // mb: 4,
            width: '100%',
            // maxWidth: 'md',
            // backgroundColor: 'whitesmoke',
            backgroundColor: width <= positionChangeWidthSm ? 'black' : 'black',
            boxShadow: 3,
            // borderRadius: '5px',
            display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
          }}
        >
          <Box
            sx={{
              pb: width <= positionChangeWidthSm ? 10 : 12, 
              pt: width <= positionChangeWidthSm ? 10 : 9,
              pl: 0,
              width: '90%',
              maxWidth: '600px',
            }}
          >
            {videoInsert('https://www.youtube.com/embed/2lPOc4zYjOc', 'Introducing Swipelytics', '100%', width)}
          </Box>
        </Box>

        {/* Demo */}
        <Demo fromHomepage={true} />

        {/* Testimonial 2 */}
        {singleTestimonialJSX(
          `I went from one interesting match every 3 weeks to 3 interesting matches a week” — Alex, 26, New York`
        )}

        
        {/* Graphics with Text Underneath */}
        {(
          width >= positionChangeWidthSm 
          || width < positionChangeWidthSm
        )
        &&
          <Box 
            sx={{
              backgroundColor: 'whitesmoke',
              pt: 4, pb: 4,
              width: '100%', height: width > positionChangeWidthSm ? '275px' : '600px',
              // backgroundColor: 'darkgray',
              display: 'flex', flexDirection: width > positionChangeWidthSm ? 'row' : 'column', justifyContent: 'space-around', alignItems: 'center',
            }}
          >

            {/* Expert Reviews Image + Text */}
            {iconImagePlusText(expertReviewIconBlue, 'Expert Reviews', '1,000+')}

            {/* AI Reviews Image + Text */}
            {iconImagePlusText(aiReviewIconBlue, 'AI Reviews', '30,000+')}

            {/* Friend Reviews Image + Text */}
            {iconImagePlusText(friendReviewIconBlue, 'Friend Reviews', '100,000+')}
          </Box>
        }

        {/* Testimonial 3 */}
        {singleTestimonialJSX(
          `"I now choose who I date rather than settling for people who were never my type" — Casey, 30, Austin`
        )}

        {/* FAQ */}
        <FAQ fromComponent='home' />

      </Box>
    </>
  )
}

export default Home